import { store } from "../store/store";
import { clearAuth } from "../store/slices/authSlice";
import { isNullOrUndefined } from "./Tools";

interface ApiResponse<T> {
  data: T;
  message: string;
}

const checkIfOnline = async () => {
  return await fetch("https://www.google.com", {
    method: "GET",
    mode: "no-cors",
  })
    .then(() => true)
    .catch((err) => {
      if (import.meta.env.DEV) console.log(err);
      return false;
    });
};

function isString(value: unknown): value is string {
  return typeof value === "string";
}

export async function apiFetch<T>(
  url: string,
  options: RequestInit,
): Promise<T> {
  const baseUrl = localStorage.getItem("url");
  const token = store.getState().root.auth.token;

  if (!baseUrl) {
    throw new Error("Base URL not found in local storage.");
  }

  if (token) {
    options.headers = {
      ...options.headers,
      Authorization: token,
    };
  }

  const fullUrl = `${baseUrl}${url}`;

  try {
    const response = await fetch(fullUrl, options);

    if (!response.ok) {
      if (response.status === 401) {
        handleUnauthorized();
      }
      const userId: string = store.getState().root.auth.id;
      if (isNullOrUndefined(userId) || userId === "") {
        handleUnauthorized();
      }
      if (response.status === 404) {
        throw new Error("Endpoint Unavailable");
      } else {
        // Handle other non-ok statuses and propagate the error message from the API
        const errorData: ApiResponse<T> = await response.json();
        throw new Error(errorData.message || "API Error");
      }
    }
    if (
      !fullUrl.includes("AddStockCheckUser") &&
      !fullUrl.includes("RemoveStockCheckUser") &&
      !fullUrl.includes("DeleteLockedPurchaseOrder") &&
      !fullUrl.includes("AddPurchaseOrderLock")
    ) {
      const responseData: ApiResponse<T> = await response.json();
      return responseData.data;
    } else {
      return {} as T;
    }
  } catch (err: unknown) {
    let message = err;

    if (err instanceof Error) {
      message = err.message;
    }

    if (
      isString(message) &&
      (message.includes("Failed to fetch") || message.includes("Load failed"))
    )
      if (await checkIfOnline())
        throw new Error(
          "Incorrect URL or service offline. Please check the URL and try again.",
        );
      else throw new Error("You appear to be offline.");
    else if (
      isString(message) &&
      (message.includes("Unexpected token") ||
        message.includes("string did not match the expected pattern"))
    )
      throw new Error("URL format invalid");
    else if (
      isString(message) &&
      message.includes("IDT has not been dispatched")
    ) {
      if (import.meta.env.DEV) console.log(message);
      throw new Error(
        "This IDT has not been dispatched. Please contact despatching depot.",
      );
    } else if (
      isString(message) &&
      message.includes("supplier uses Import Charges")
    ) {
      if (import.meta.env.DEV) console.log(message);
      throw new Error(
        "This order needs to be received by Gold as the supplier uses Import Charges",
      );
    } else if (isString(message)) {
      if (import.meta.env.DEV) console.log(message);
      throw new Error("An unexpected error occurred. Please try again.");
    } else throw err;
  }
}

let isHandlingUnauthorized = false;
function handleUnauthorized() {
  if (isHandlingUnauthorized) return;
  isHandlingUnauthorized = true;
  localStorage.setItem("FORCED_OUT", "true");
  store.dispatch(clearAuth());
  // PrivateRoute in App.tsx will redirect to /login when token is cleared.
  // Reset guard on next tick so subsequent logouts (after re-login) can fire.
  setTimeout(() => {
    isHandlingUnauthorized = false;
  }, 0);
}
